<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<div class="container">
  <div class="row">
    <p class="alert alert-info col-12">{{ title}}</p>
    <div class="col-12">
      <form class='bg-light p-2'>
        <div class="row">
          <div class="col-12">
            <input type="text" class="form-control col-md-4 col-sm-6 pull-right text-danger font-weight-bold"
              [(ngModel)]="catFichaInmaterial.codregistro" name="codregistro" placeholder="Cod. Registro">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input type="text" class="form-control col-md-4 col-sm-6 pull-right text-danger font-weight-bold"
              [(ngModel)]="catFichaInmaterial.ubicacion_manifestacion" name="ubicacion_manifestacion" placeholder="Ubicación de la Manifestación">
          </div>
        </div>

        <div class="row my-2">
          <div class="col-md-6 col-sm-12">
            <div class="row">
              <div class="col-sm-12">
                <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.nombre_manifestacion"
                  name="nombre_manifestacion" placeholder="Nombre de la Manifestación">
                <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.nombre_representante"
                  name="nombre_representante" placeholder="Nombre del Representante">
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                
                  <div class="form-group">
                    <label for="mt_marco_temporal" class="mt-3 mb-0">Marco Temporal</label>
                    <select name="mt_marco_temporal"  class="custom-select" [(ngModel)]="catFichaInmaterial.mt_marco_temporal">
                      <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                      <option *ngFor="let mt_marco_temporal of marcosTemporales">{{mt_marco_temporal}}</option>
                    </select>
                  </div>  
                <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.mt_fecha_celebracion"
                  name="mt_fecha_celebracion" placeholder="Fecha de Celebración">

                <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.mt_desc_obs"
                
                  data=" Descripción / Observaciones" name="mt_desc_obs">
                </ckeditor>
              </div>
              <div class="col-md-6 col-sm-12">
                
                  <div class="form-group">
                    <label for="tm_tema" class="mt-3 mb-0">Tema</label>
                    <select name="tm_tema" class="custom-select" [(ngModel)]="catFichaInmaterial.tm_tema">
                      <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                      <option *ngFor="let tm_tema of Temas">{{tm_tema}}</option>
                    </select>
                  </div>
                <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.tm_desc_obs"
                  data=" Descripción / Observaciones" name="tm_desc_obs">
                </ckeditor>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                
                  <div class="form-group">
                    <label for="ea_estado_actual"  class="mt-3 mb-0">Estado Actual</label>
                    <select name="ea_estado_actual" class="custom-select" [(ngModel)]="catFichaInmaterial.ea_estado_actual">
                      <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                      <option *ngFor="let ea_estado_actual of estadosActuales">{{ea_estado_actual}}</option>
                    </select>
                  </div>  
                <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.ea_desc_obs"
                  data=" Descripción / Observaciones" name="ea_desc_obs">
                </ckeditor>
              </div>
              <div class="col-md-6 col-sm-12">
                
                  <div class="form-group">
                    <label for="tca_trasc_cultural_alcance" class="mt-3 mb-0">Trascendencia Cultural Alcance</label>
                    <select name="tca_trasc_cultural_alcance" class="custom-select" [(ngModel)]="catFichaInmaterial.tca_trasc_cultural_alcance">
                      <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                      <option *ngFor="let tca_trasc_cultural_alcance of trascendenciasCulturalesAlcances">{{tca_trasc_cultural_alcance}}</option>
                    </select>
                  </div>    
                <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.tca_desc_obs"
                  data=" Descripción / Observaciones" name="tca_desc_obs">
                </ckeditor>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            
              <div class="form-group">
                <label for="mh_manifestacion_herencia" class="mt-3 mb-0">Manifestación de Herencia</label>
                <select name="mh_manifestacion_herencia" class="custom-select" [(ngModel)]="catFichaInmaterial.mh_manifestacion_herencia">
                  <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                  <option *ngFor="let mh_manifestacion_herencia of manifestacionesHerencia">{{mh_manifestacion_herencia}}</option>
                </select>
              </div>                
            <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.mh_agno_ref_expresion_cultural"
              name="mh_agno_ref_expresion_cultural" placeholder="Año referencial de la Exp. Cultural">
            <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.mh_titulo" name="mh_titulo"
              placeholder="Descripción">
            <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.mh_descripcion" data="Descripción"
              name="mh_descripcion">
            </ckeditor>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            
              <div class="form-group">
                <label for="roepd1_element_destacables" class="mt-3 mb-0">Reg. de Otros Elementos / Procesos que destacan</label>
                <select name="roepd1_element_destacables" class="custom-select" [(ngModel)]="catFichaInmaterial.roepd1_element_destacables">
                  <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                  <option *ngFor="let roepd1_element_destacables of elementosProcesos">{{roepd1_element_destacables}}</option>
                </select>
              </div>  
            <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.roepd1_desc_obs"
              data=" Descripción / Observaciones" name="roepd1_desc_obs">
            </ckeditor>


          </div>
          <div class="col-md-6 col-sm-12">
            
              <div class="form-group">
                <label for="roepd2_element_destacables" class="mt-3 mb-0">Reg. de Otros Elementos / Procesos que destacan</label>
                <select name="roepd2_element_destacables" class="custom-select" [(ngModel)]="catFichaInmaterial.roepd2_element_destacables">
                  <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                  <option *ngFor="let roepd2_element_destacables of elementosProcesos">{{roepd2_element_destacables}}</option>
                </select>
              </div>   
            <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.roepd2_desc_obs"
              data=" Descripción / Observaciones" name="roepd2_desc_obs">
            </ckeditor>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            
              <div class="form-group">
                <label for="roepd3_element_destacables" class="mt-3 mb-0">Reg. de Otros Elementos / Procesos que destacan</label>
                <select name="roepd3_element_destacables" class="custom-select" [(ngModel)]="catFichaInmaterial.roepd3_element_destacables">
                  <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                  <option *ngFor="let roepd3_element_destacables of elementosProcesos">{{roepd3_element_destacables}}</option>
                </select>
              </div>  
            <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.roepd3_desc_obs"
              data=" Descripción / Observaciones" name="roepd3_desc_obs">
            </ckeditor>
          </div>
          <div class="col-md-6 col-sm-12">
            
              <div class="form-group">
                <label for="ouc_otros_usos_costumbres" class="mt-3 mb-0">Otros Usos y Costumbres</label>
                <select name="ouc_otros_usos_costumbres" class="custom-select" [(ngModel)]="catFichaInmaterial.ouc_otros_usos_costumbres">
                  <!--<option selected value="Marco-Temporal">Marco-Temporal</option>-->
                  <option *ngFor="let ouc_otros_usos_costumbres of elementosProcesos">{{ouc_otros_usos_costumbres}}</option>
                </select>
              </div>   
            <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.ouc_desc_obs"
              data=" Descripción / Observaciones" name="ouc_desc_obs">
            </ckeditor>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-12">
            <ckeditor [editor]="Editor" [(ngModel)]="catFichaInmaterial.observaciones" data="Observaciones"
              name="observaciones">
            </ckeditor>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-md-6 col-sm-12">
            <p>Coordinador responsable</p>
            <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.coord_nombre"
              name="coord_nombre" placeholder="Nombre(s) Coodinador(ra)">
          </div>
          <div class="col-md-6 col-sm-12">
            <p>Catalogador(es) responsable(s)</p>
            <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.cata1_nombre"
              name="cata1_nombre" placeholder="Nombre(s) Catalogador(a) 1">
            <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.cata2_nombre"
              name="cata2_nombre" placeholder="Nombre(s) Catalogador(a) 2">
            <input type="text" class="form-control my-2" [(ngModel)]="catFichaInmaterial.cata3_nombre"
              name="cata3_nombre" placeholder="Nombre(s) Catalogador(a) 3">
          </div>
        </div>
        <div class="row my-2">
          <div class="col-md-6 col-sm-12">
            <p>Fecha/Hora</p>
            <input type="datetime-local" name="birthdaytime" [(ngModel)]="catFichaInmaterial.fecha">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-6">
            <button class="btn btn-primary" role="button" (click)='crearFichaInmaterial()' *ngIf="!catFichaInmaterial.id else elseBlock">Guardar</button>
            <!--creamos un template para procesar el "boton" UPDATE -->
            <ng-template #elseBlock>
              <button class="btn btn-primary" role="button" (click)='actualizarFichaInmaterial()' >Actualizar</button>
            </ng-template>
            
          </div>
        </div>
      </form>
    </div>
  </div>
</div>